module.exports = __webpack_public_path__ + "static/media/iphone.ad4091ff.svg";